import { ClickAwayListener, Divider, Grid } from '@mui/material';
import React, { useContext } from 'react';
import { classes, TestIdIdentifier } from '../../../../util/identifiers/identifiers.util';
import { CompanyContext } from '../../../../context/CompanyContext';
import { handleKeyEvent } from '../../../../util/events.util';
import CloseIcon from '../../../icons/Close/CloseIcon';
import { ModalBackdrop } from './components';
import ErrorBox from '../../../../ui/pages/Common/ErrorBox';
import { Colors } from '../../../util/color.util';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
  icon?: React.ReactNode;
  height?: string;
  error?: string;
  width?: string;
  testId?: TestIdIdentifier;
  className?: string;
  header?: React.ReactNode;
  customLayout?: boolean;
}

export default function Modal({
  open,
  onClose,
  children,
  title,
  icon,
  error,
  width,
  testId,
  className,
  height,
  header,
  customLayout = false,
}: ModalProps) {
  if (!open) return null;

  const { currentCompany } = useContext(CompanyContext);

  document.addEventListener('keydown', event => handleKeyEvent(event, 'Escape', onClose), false);

  return (
    <ModalBackdrop>
      <ClickAwayListener
        mouseEvent={'onMouseDown'}
        onClickAway={event => {
          event.stopPropagation();
          onClose();
        }}
      >
        <Grid
          container
          data-testid={testId?.name}
          className={`${classes.modal.name} ${className || ''} rounded-4 bg-white`}
          width={width || '60%'}
          marginX={'auto'}
          tabIndex={1}
        >
          {customLayout ? (
            children
          ) : (
            <Grid item xs={12}>
              <Grid container>
                {header || (
                  <>
                    <Grid item xs={12} className={'content-center px-6 py-3'}>
                      <Grid container>
                        {icon ? (
                          <Grid
                            item
                            alignContent={'center'}
                            color={Colors.getPrimaryColor(currentCompany)}
                            className='pr-4'
                          >
                            {icon}
                          </Grid>
                        ) : null}
                        <Grid item flexGrow={1} className={'content-center'}>
                          <p className='select-none text-xl font-semibold'>{title}</p>
                        </Grid>

                        <CloseIcon
                          className='flex h-[44px] w-[44px] cursor-pointer items-center justify-center rounded-[8px] text-gray-500 hover:bg-gray-100 hover:text-black'
                          onClick={onClose}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  </>
                )}

                {error ? (
                  <Grid item xs={12} className='px-6 pt-2'>
                    <ErrorBox error={error} />
                  </Grid>
                ) : null}

                <Grid item xs={12} height={height || 'auto'}>
                  {children}
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </ClickAwayListener>
    </ModalBackdrop>
  );
}
